import BackendConnector from './backendConnector';

export default class AutoCampaignHttpService {
    static getAutoCampaign(positionId) {
        return BackendConnector.get(`position/${positionId}/autoCampaign`);
    }

    static searchAutoCampaign(filter, projection) {
        return BackendConnector.post('/autoCampaign/search', { filter, projection });
    }

    static switchAutoCampaign(positionId, autoCampaign) {
        return BackendConnector.post(`/position/${positionId}/autoCampaign`, { autoCampaign });
    }

    static registerManualEvent(positionId, { eventName, talentIds = [] }) {
        return BackendConnector.post(`/position/${positionId}/autoCampaign/event/manual`, { eventName, talentIds });
    }
}
